import React, { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  title?: string | ReactNode;
  footer?: ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  border?: boolean;
  shadow?: 'none' | 'sm' | 'md' | 'lg';
  rounded?: 'none' | 'sm' | 'md' | 'lg';
  hover?: boolean;
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({
  children,
  title,
  footer,
  className = '',
  padding = 'md',
  border = true,
  shadow = 'md',
  rounded = 'md',
  hover = false,
  onClick
}) => {
  // Base styles
  let baseStyle = 'bg-background-primary text-text-primary';
  
  // Padding styles
  const paddingStyles = {
    none: '',
    sm: 'p-2',
    md: 'p-4',
    lg: 'p-6'
  };
  
  // Border style
  const borderStyle = border ? 'border border-border-light dark:border-border-medium' : '';
  
  // Shadow styles
  const shadowStyles = {
    none: '',
    sm: 'shadow-sm',
    md: 'shadow-card',
    lg: 'shadow-lg'
  };
  
  // Rounded styles
  const roundedStyles = {
    none: 'rounded-none',
    sm: 'rounded-sm',
    md: 'rounded',
    lg: 'rounded-lg'
  };
  
  // Hover style
  const hoverStyle = hover 
    ? 'transition-all duration-200 hover:shadow-lg hover:border-border-medium dark:hover:border-border-heavy cursor-pointer'
    : '';
  
  // Combine styles
  const combinedClassName = `${baseStyle} ${paddingStyles[padding]} ${borderStyle} ${shadowStyles[shadow]} ${roundedStyles[rounded]} ${hoverStyle} ${className}`;
  
  return (
    <div className={combinedClassName} onClick={onClick}>
      {title && (
        <div className={`${typeof title === 'string' ? 'font-medium text-lg text-text-primary' : ''} ${padding !== 'none' ? 'mb-4' : ''}`}>
          {title}
        </div>
      )}
      
      <div>{children}</div>
      
      {footer && (
        <div className={`${padding !== 'none' ? 'mt-4 pt-4 border-t border-border-light dark:border-border-medium' : ''}`}>
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card;